import { LocalStorage } from '../helpers/storage';

export const isAuthenticated = () => {
  const token = LocalStorage.get('token');
  return token && token.length > 0;
};
